export default {
    labels: {
        type: Object,
        required: true
    },
    previousStepCallback: {
        type: Function,
        required: true
    },
    nextStepCallback: {
        type: Function,
        required: true
    },
    skipStepCallback: {
        type: Function,
        required: false,
        default: () => {}
    },
    displayInputError: {
        type: Boolean,
        required: true,
        default: false
    },
    submitCallback: {
        type: Function,
        required: true
    },
    updateBasketCallback: {
        type: Function,
        required: false,
        default: () => {}
    },
    stafetId: {
        type: String,
        required: true
    },
    holdId: {
        type: String,
        required: false
    },
    tshirtSizes: {
        type: Array,
        required: false,
        default: []
    },
    donationAmounts: {
        type: Array,
        required: false,
        default: []
    },
    loggedIn: {
        type: Boolean,
        required: false,
        default: false
    },
    holdData: {
        type: Object,
        required: false,
        default: {}
    },
    holdList: {
        type: Array,
        required: false,
        default: []
    },
    userData: {
        type: Object,
        required: false,
        default: {}
    },
    redirectToEditProfile: {
        type: String,
        required: false,
        default: ''
    },
    editProfileLinkText: {
        type: String,
        required: false,
        default: ''
    },
    lysposeMinimumAmount: {
        type: Number,
        required: false,
        default: 50
    },
    donationMinimumAmount: {
        type: Number,
        required: false,
        default: 50
    },
    isSubmitting: {
        type: Boolean,
        required: false,
        default: false
    }
}
